const createSavedSearchTrackingService = (track: (category: string, action: string, name: string) => void) => {
    return {
        trackSavedSearchOptionsToggled(isOpen: boolean) {
            if (isOpen) {
                track("saved search settings", "click saved search options", "open saved search options");
            }
        },
    };
};

export default createSavedSearchTrackingService;
